
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { SchoolIdentityUserDto } from "@/api/service-proxies";
import { faceTempleteService } from "@/api/payments/faceTempleteService";
import { UserSimpleDto } from "@/api/service-proxies";

@Component({})
export default class ParentDetail extends Vue {
  @Prop()schoolIdentityUsers!: SchoolIdentityUserDto[] 




created(){

}




}
